import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';

export type GetContentPromotions = {
  promotionTypes: PROMOTION_TYPES[];
  t: TranslationFunction;
  searchParams: SearchParams;
  imageBasePath: string;
};

export const getContentPromotions = ({
  promotionTypes,
  // searchParams,
  t,
  // imageBasePath,
}: GetContentPromotions): Feature[] => {
  const offers: Feature[] = [];

  promotionTypes.forEach((promotionType) => {
    // Deprecated
    // if (promotionType === PROMOTION_TYPES.LONDON_EYE) {
    //   offers.push({
    //     text: t('vacation.oss.cards.london_eye_label'),
    //     icon: { category: 'Services', name: 'icon-tickets', color: '#000000' } as const,
    //     featureType: FeatureType.offer,
    //   });
    // }

    // Deprecated
    // if (promotionType === PROMOTION_TYPES.TOUR_DE_FRANCE) {
    //   offers.push({
    //     text: t('vacation.oss.cards.tour_de_france_label'),
    //     icon: { category: 'Services', name: 'icon-tickets', color: '#000000' } as const,
    //     featureType: FeatureType.offer,
    //   });
    // }

    if (promotionType === PROMOTION_TYPES.TICKETS) {
      offers.push({
        text: t('vacation.oss.cards.tickets_included'),
        // icon: { category: 'Services', name: 'icon-tickets', color: '#000000' } as const,
        featureType: FeatureType.normal,
      });
    }

    // Deprecated
    // if (promotionType === PROMOTION_TYPES.TRANSFER) {
    //   const isTourOperatorHO =
    //     promotionTypes?.includes(PROMOTION_TYPES.TO_FR) && searchParams?.searchMode === SearchModes.HO;
    //   if (!isTourOperatorHO) {
    //     offers.push({
    //       text: t('vacation.oss.cards.transfer_included'),
    //       // icon: { category: 'Services', name: 'icon-tickets', color: '#000000' } as const,
    //       featureType: FeatureType.normal,
    //     });
    //   }
    // }

    if (promotionType === PROMOTION_TYPES.SKIPASS) {
      offers.push({
        text: t('vacation.oss.cards.ski_pass_included'),
        // icon: { category: 'Services', name: 'icon-tickets', color: '#000000' } as const,
        featureType: FeatureType.normal,
      });
    }

    if (promotionType === PROMOTION_TYPES.SPA) {
      offers.push({
        text: t('vacation.oss.cards.spa_included'),
        // icon: { category: 'Services', name: 'icon-tickets', color: '#000000' } as const,
        featureType: FeatureType.normal,
      });
    }

    if (promotionType === PROMOTION_TYPES.RESORT_CREDIT) {
      offers.push({
        text: t('vacation.oss.cards.usp.resort_credits_available'),
        featureType: FeatureType.normal,
      });
    }
  });

  return offers;
};
